/* eslint-disable import/prefer-default-export */
import { race, call, put, select } from 'redux-saga/effects';
import { delay } from 'redux-saga';
import * as clientNoticesActions from '../modules/main/reducers/static/states/clientNotices/reducer';

const TIMEOUT_IN_SECONDS = 40;
const getState = state => state;

/**
 *  Обертка вызова сервисов(запрос к api) из saga для логики общего поведения обработки запросов.
 */
export function* timeoutCall(serviceFunc, ...args) {
  const state = yield select(getState);
  try {
    const { data, timeout } = yield race({
      data: call(serviceFunc, state, ...args),
      timeout: call(delay, 1000 * TIMEOUT_IN_SECONDS)
    });
    // console.log(data);
    if (data) {
      // Добавляем клиентское уведомление если не достаточно прав для выполнения запроса
      // TODO Стандартизировать все реструктуризации ответов в api сервисах (data.status or data.response.status...)
      if (
        [400, 401, 403, 413, 423, 424, 500, 502, 503, 504].includes(data.status)
      ) {
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'error',
            // title: 'Запрещено',
            message: data.data.message
          })
        );
      } else if (
        data.response &&
        [400, 401, 403, 413, 423, 424, 500, 502, 503, 504].includes(
          data.response.status
        )
      ) {
        yield put(
          clientNoticesActions.addClientNotice({
            type: 'error',
            // title: 'Запрещено',
            message: data.response.data.message
          })
        );
      }
      return data;
    } else if (timeout) {
      // Добавляем клиентское уведомление если отработал таймаут
      yield put(
        clientNoticesActions.addClientNotice({
          type: 'error',
          title: 'Таумаут запроса',
          message: 'Не удалось выполнить запрос к серверу'
        })
      );
    }
    return null;
  } catch (error) {
    // Добавляем клиентское уведомление если брайзер не смог отправить запрос
    // (например по причине CORS, ошибке в fetch обертке и тп)
    console.log(serviceFunc);
    console.log(error);
    yield put(
      clientNoticesActions.addClientNotice({
        type: 'error',
        title: 'Ошибка api клиента',
        message: 'Не удалось выполнить запрос к серверу'
      })
    );
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/mt-react-common/utils/sagaHalper.js